module.exports = __webpack_public_path__ + "static/assets/1b65479d80c67d092bc5893ed66a0ec0.svg";